import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import heroImage from "../assets/Images/hero-8.jpg";

const IntroSection = () => {
  return (
    <Box
      id="hero-8"
      sx={{
        position: "relative",
        borderBottom: "4px solid #c6db8c",
        height: { xs: "auto", md: "80vh" },
        backgroundImage: `url(${heroImage})`, // اپنی image کا path دیں
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: { xs: "60px 20px", md: "0" },
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "black",
          opacity: 0.3,
          zIndex: 0,
        }}
      />

      <Container sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.2rem",
            color: "white",
            fontWeight: 600,
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          Safe Place is the number one choice for screening and background
          checks and enquiries for employees in West Africa. We deploy the
          latest technology and smart solutions to make sure that you get
          reliable information about the people that will be recruited to a
          team.
          <br />
          <br />
          Our research shows that employers find it difficult to find relevant
          information on candidates they wish to employ or promote – struggling
          to verify the information provided on their CVs or Identity documents.
          Safe Place is changing that! We mitigate employment risk by working
          with a network of partners to deliver unbiased information – all at
          your fingertips!
        </Typography>

        <Box sx={{ mt: 5 }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#b4d78d", // light green
              color: "#666", // updated text color
              fontWeight: 600,
              height: "50px", // fixed height
              width: "220px", // fixed width
              fontWeight: 600,
              "&:hover": { backgroundColor: "#a1c97b", color:'#ffff' },
            }}
            href="#about"
          >
            Discover More
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default IntroSection;
